import { FilterType } from "src/api/types";
import ProductCategoryFilter from "src/components/ProductCategoryFilter";
import { CATEGORY } from "src/constants/searchParams";

export const filters: FilterType[] = [
  {
    name: CATEGORY,
    placeholder: "Category",
    type: "custom",
    component: ProductCategoryFilter,
  },
];
